module.exports = __webpack_public_path__ + "img/moon.69f1dac.svg";